import React from 'react';
import { Button, Callout, Intent } from '@blueprintjs/core';

import { apiClient } from '@f/api-client';
import { saveAsJson } from '@f/utils/export';

import cls from './BatchSearchDetailsExport.module.css';

export function BatchSearchDetailsExport({ batchId }: { batchId: string }) {
  const [isExporting, setIsExporting] = React.useState(false);
  const [exportingError, setExportingError] = React.useState('');

  const exportSearchDetails = async () => {
    setIsExporting(true);
    setExportingError('');
    try {
      const { status, body } = await apiClient.search.fetchPublicSearchDetails({
        params: {
          searchId: batchId,
        },
      });

      if (status !== 200) {
        setExportingError('Fetching data to export failed');
        return;
      }

      saveAsJson(body, `search-${batchId}-details.json`);
    } catch (error) {
      setExportingError(error instanceof Error ? error.message : String(error));
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className={cls.detailsExportWrapper}>
      <Button
        text="Export more details as JSON"
        loading={isExporting}
        intent={Intent.PRIMARY}
        large
        onClick={exportSearchDetails}
      />
      {exportingError && <Callout intent={Intent.DANGER}>{exportingError}</Callout>}
    </div>
  );
}
